/** Which Cognito path a tenant's login surface initiates (REQ-001). */
export enum LoginMethod {
	NATIVE = 'NATIVE',
	SAML = 'SAML',
	/** A tenant OIDC provider federated through Cognito (TO-378). */
	OIDC = 'OIDC',
}

/** The audited SSO-config writes carried on `tenant.idp_updated`. */
export enum TenantIdpAction {
	ATTACHED = 'ATTACHED',
	ROTATED = 'ROTATED',
	TEST_PASSED = 'TEST_PASSED',
	TEST_FAILED = 'TEST_FAILED',
	DISABLED = 'DISABLED',
	/** The tenant's JIT provisioning config was replaced (TO-335). */
	JIT_UPDATED = 'JIT_UPDATED',
	/** A tenant identity provider was created (TO-410 REQ-013). */
	PROVIDER_CREATED = 'PROVIDER_CREATED',
	/** A provider's name or configuration was replaced (TO-410). */
	PROVIDER_UPDATED = 'PROVIDER_UPDATED',
	/** A provider was switched on (TO-410). */
	PROVIDER_ENABLED = 'PROVIDER_ENABLED',
	/** A provider was switched off; its Cognito provider and linked identities are kept (TO-410). */
	PROVIDER_DISABLED = 'PROVIDER_DISABLED',
	/** The tenant's default provider pointer changed (TO-410). */
	DEFAULT_CHANGED = 'DEFAULT_CHANGED',
	/** Any other replace of the tenant's authentication config (TO-410). */
	AUTH_CONFIG_UPDATED = 'AUTH_CONFIG_UPDATED',
	/** A provider's attribute mapping got a new version (TO-377 REQ-010). */
	ATTRIBUTE_MAPPING_UPDATED = 'ATTRIBUTE_MAPPING_UPDATED',
	/** The tenant's SCIM token was issued or rotated (TO-379). Never carries the token or its hash. */
	SCIM_TOKEN_ISSUED = 'SCIM_TOKEN_ISSUED',
	/** The tenant's SCIM token was revoked (TO-379). */
	SCIM_TOKEN_REVOKED = 'SCIM_TOKEN_REVOKED',
	/** The tenant's SCIM attribute mapping got a new version (TO-379). */
	SCIM_MAPPING_UPDATED = 'SCIM_MAPPING_UPDATED',
}

/** Where the tenant's SAML metadata comes from: exactly one of a URL or an inline document. */
export type SamlMetadataSource = { url: string } | { xml: string }

/** The SAML assertion attribute names the tenant's IdP sends. */
export interface IdpAttributeMapping {
	/** Assertion attribute carrying the user's email. */
	email: string
	/** Assertion attribute carrying the group marker — a signal only, never authority. */
	groups?: string
	/**
	 * Assertion attribute carrying the IdP's MFA assertion (TO-63 REQ-012), projected
	 * into `custom:idp_mfa`. Absent: OIDC providers project `amr`; SAML projects none.
	 */
	mfa?: string
}

/** The outcome of the latest server-verified test login. */
export interface IdpLastTest {
	passed: boolean
	at: string
}
